import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol1006 = React.lazy(() => import('./symbols/1006_puzzle_module_part'));
const Symbol1007 = React.lazy(() => import('./symbols/1007_chess_crown_queen'));
const Symbol1008 = React.lazy(() => import('./symbols/1008_gamepad_video_game_playing'));
const Symbol1009 = React.lazy(() => import('./symbols/1009_bowling_ball_pins'));
const Symbol1010 = React.lazy(() => import('./symbols/1010_archery_target_shooting'));
const Symbol1011 = React.lazy(() => import('./symbols/1011_holiday_seaside_relax'));
const Symbol1012 = React.lazy(() => import('./symbols/1012_drums_playing_sound'));
const Symbol1013 = React.lazy(() => import('./symbols/1013_abacus_math_calculator_school'));
const Symbol1014 = React.lazy(() => import('./symbols/1014_cards_playing_poker_casino'));
const Symbol1015 = React.lazy(() => import('./symbols/1015_playing_dice_casino'));
const Symbol1016 = React.lazy(() => import('./symbols/1016_pacman_game'));
const Symbol1017 = React.lazy(() => import('./symbols/1017_pacman_enemy_game'));
const Symbol1018 = React.lazy(() => import('./symbols/1018_coffin'));
const Symbol1019 = React.lazy(() => import('./symbols/1019_domino_numbers_game'));
const Symbol1020 = React.lazy(() => import('./symbols/1020_baloons_party_birthday'));
const Symbol1021 = React.lazy(() => import('./symbols/1021_masks_theater_play'));
const Symbol1022 = React.lazy(() => import('./symbols/1022_chess_horse_game'));
const Symbol1023 = React.lazy(() => import('./symbols/1023_billiard_cue_balls_pool'));
const Symbol1024 = React.lazy(() => import('./symbols/1024_guitar_playing_music_band'));
const Symbol1025 = React.lazy(() => import('./symbols/1025_seashell'));
const Symbol1026 = React.lazy(() => import('./symbols/1026_submarine_underwater_sea_diving'));
const Symbol1027 = React.lazy(() => import('./symbols/1027_diving_mask_gear_sea_underwater'));
const Symbol1028 = React.lazy(() => import('./symbols/1028_sea_waves'));
const Symbol1029 = React.lazy(() => import('./symbols/1029_bikini_swimwear'));
const Symbol1030 = React.lazy(() => import('./symbols/1030_hat'));
const Symbol1031 = React.lazy(() => import('./symbols/1031_flipflops'));
const Symbol1032 = React.lazy(() => import('./symbols/1032_sunglasses'));

export interface IProps {}

const Leisure: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="1006_puzzle_module_part" symbol={<Symbol1006 />} />
      <LazySymbol id="1007_chess_crown_queen" symbol={<Symbol1007 />} />
      <LazySymbol id="1008_gamepad_video_game_playing" symbol={<Symbol1008 />} />
      <LazySymbol id="1009_bowling_ball_pins" symbol={<Symbol1009 />} />
      <LazySymbol id="1010_archery_target_shooting" symbol={<Symbol1010 />} />
      <LazySymbol id="1011_holiday_seaside_relax" symbol={<Symbol1011 />} />
      <LazySymbol id="1012_drums_playing_sound" symbol={<Symbol1012 />} />
      <LazySymbol id="1013_abacus_math_calculator_school" symbol={<Symbol1013 />} />
      <LazySymbol id="1014_cards_playing_poker_casino" symbol={<Symbol1014 />} />
      <LazySymbol id="1015_playing_dice_casino" symbol={<Symbol1015 />} />
      <LazySymbol id="1016_pacman_game" symbol={<Symbol1016 />} />
      <LazySymbol id="1017_pacman_enemy_game" symbol={<Symbol1017 />} />
      <LazySymbol id="1018_coffin" symbol={<Symbol1018 />} />
      <LazySymbol id="1019_domino_numbers_game" symbol={<Symbol1019 />} />
      <LazySymbol id="1020_baloons_party_birthday" symbol={<Symbol1020 />} />
      <LazySymbol id="1021_masks_theater_play" symbol={<Symbol1021 />} />
      <LazySymbol id="1022_chess_horse_game" symbol={<Symbol1022 />} />
      <LazySymbol id="1023_billiard_cue_balls_pool" symbol={<Symbol1023 />} />
      <LazySymbol id="1024_guitar_playing_music_band" symbol={<Symbol1024 />} />
      <LazySymbol id="1025_seashell" symbol={<Symbol1025 />} />
      <LazySymbol id="1026_submarine_underwater_sea_diving" symbol={<Symbol1026 />} />
      <LazySymbol id="1027_diving_mask_gear_sea_underwater" symbol={<Symbol1027 />} />
      <LazySymbol id="1028_sea_waves" symbol={<Symbol1028 />} />
      <LazySymbol id="1029_bikini_swimwear" symbol={<Symbol1029 />} />
      <LazySymbol id="1030_hat" symbol={<Symbol1030 />} />
      <LazySymbol id="1031_flipflops" symbol={<Symbol1031 />} />
      <LazySymbol id="1032_sunglasses" symbol={<Symbol1032 />} />
    </>
  );
});

Leisure.displayName = 'Leisure';

export default Leisure;
